import React, { useEffect } from 'react';
import { Modal } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import useActivateMerchant from 'Hooks/query-hooks/single-merchant/useActivateMerchant';
import styles from './ActivateMerchantModal.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    merchantId: string;
    templateRepositoryId: number;
    merchantEnabled: boolean;
};

const ActivateMerchantModal = ({
    isOpen,
    onClose,
    merchantId,
    onSuccess,
    templateRepositoryId,
    merchantEnabled
}: Props) => {
    const { t } = useTranslation();
    const actionToDo = merchantEnabled ? 'deactivate' : 'reactivate';
    const patchMerchantActive = useActivateMerchant(merchantId, templateRepositoryId, !merchantEnabled);

    useEffect(() => {
        if (patchMerchantActive?.isSuccess) {
            onSuccess?.();
            onClose();
            patchMerchantActive.reset();
        }
    }, [patchMerchantActive, onClose, onSuccess]);

    return (
        <Modal
            dataTestId='activate-merchant-modal'
            isOpen={isOpen}
            closeModal={onClose}
            status='warning'
            containerClass={styles.modalContainer}
        >
            <Modal.Title
                id='activate-merchant-title'
                title={merchantEnabled ? t('Deactivate Merchant') : t('Reactivate Merchant')}
                statusIcon='warning'
                onClose={onClose}
            />
            <div className={styles.activateWarningContent}>
                <div className={styles.merchantInfo}>
                    {t('activate warning pt1', {
                        merchantId,
                        actionToDo
                    })}
                </div>
                {merchantEnabled ? t('deactivate Merchant warning') : t('reactivate Merchant warning')}
            </div>
            <Modal.Footer
                id='activate-merchant-footer'
                onAction={() => patchMerchantActive.mutate()}
                disableOnAction={patchMerchantActive.isLoading}
                onActionText={merchantEnabled ? t('Deactivate Merchant') : t('Reactivate Merchant')}
                onClose={onClose}
                onCloseText={t('Cancel')}
            />
        </Modal>
    );
};

export default ActivateMerchantModal;
